'use client';

import ReactDOM from 'react-dom';

type PreloadFont = {
    href: string;
    type?: string;
    crossOrigin?: 'anonymous' | 'use-credentials' | '';
};

type PreloadResourcesProps = {
    fonts?: PreloadFont[];
    preconnects?: string[];
    images?: string[];
};

export default function PreloadResources({
    fonts = [],
    preconnects = [],
    images = [],
}: PreloadResourcesProps) {
    const uniqueFonts = Array.from(new Map(fonts.map((font) => [font.href, font])).values());
    const uniquePreconnects = Array.from(new Set(preconnects.filter(Boolean)));

    uniquePreconnects.forEach((href) => {
        ReactDOM.preconnect(href, { crossOrigin: 'anonymous' });
    });

    uniqueFonts.forEach((font) => {
        ReactDOM.preload(font.href, {
            as: 'font',
            ...(font.type ? { type: font.type } : {}),
            ...(font.crossOrigin ? { crossOrigin: font.crossOrigin } : {}),
        });
    });

    Array.from(new Set(images.filter(Boolean))).forEach((href) => {
        ReactDOM.preload(href, { as: 'image', fetchPriority: 'high' });
    });

    return null;
}
